import React from "react";
import useSelect from "../hooks/useSelect";
import ResultComponent from "./ResultComponent";
import { CloseIcon, Container, Question, Wrapper } from "./styled";
import 송진우이미지 from "../assets/송진우-독립운동가.gif";
import styled from "styled-components";

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<string>>;
}

const Stage5 = ({ setScreen }: Props) => {
  const ANSWER = 1; // 송진우 - 독립운동가
  const { select, onClickItem } = useSelect(ANSWER);

  return (
    <Container>
      <Question>
        이 인물은 독립운동가일까요
        <br />
        친일파일까요?
      </Question>

      <AnswerContainer>
        <Image src={송진우이미지} alt="송진우" />

        <Wrapper onClick={() => onClickItem(1)} $correct={!!select}>
          <Text>⓵ 독립운동가</Text>
          {select === 1 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(2)} $incorrect={select === 2}>
          <Text>⓶ 친일파</Text>
          {select === 2 && <CloseIcon />}
        </Wrapper>
      </AnswerContainer>

      {!!select && (
        <ResultComponent
          select={select}
          answer={ANSWER}
          nextStage={6}
          setScreen={setScreen}
          desc={
            <Desc>
              <strong>송진우</strong>
              <br />
              송진우(宋鎭禹, 1890년 6월 11일 (음력 5월 8일) ~ 1945년 12월
              30일)는 한국의 독립운동가, 정치인이며 일제강점기와 해방 직후에
              언론인, 교육자, 사상가, 정치인으로 활동하였다. 본관은 신평이며
              전라남도 담양군 고지면 손곡리 출신이다.[1] 아호는 고하(古下)이다.
              한국민주당(韓國民主黨)의 초대 당수였으며, 1919년 3·1 만세 운동
              당시 민족대표 48인의 한사람이기도 하다.
            </Desc>
          }
        />
      )}
    </Container>
  );
};

export default Stage5;

const Image = styled.img`
  width: 280px;
`;

const AnswerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

  margin-top: 20px;
`;

const Text = styled.div`
  font-size: 30px;
`;

const Desc = styled.div`
  font-size: 20px;

  & strong {
    font-size: 30px;
  }
`;
